import React, {useEffect} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Expert from './sections/Expert/Expert';
import ExpertReverse from './sections/ExpertReverse/ExpertReverse';
import Gallery from './sections/Gallery/Gallery';
import {useLocation} from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './About.scss';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import { Helmet } from 'react-helmet-async';

const klaudiaPhoto =  require('../../assets/images/experts/klaudia.jpg');
const przemekPhoto =  require('../../assets/images/experts/przemek.jpg');
const piotrPhoto =  require('../../assets/images/experts/piotr.jpg');
const karolinaPhoto =  require('../../assets/images/experts/karolina.jpg');
const marcinPhoto = require('../../assets/images/experts/marcin.jpg');
// const dariaPhoto = require('../../assets/images/experts/daria.jpg');
const zuzannaPhoto = require('../../assets/images/experts/zuzanna.jpg');
const izabelaPhoto = require('../../assets/images/experts/izabela.jpg');
const About = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            setTimeout(() => {
                const element = document.querySelector(decodeURIComponent(location.hash));
                if (element) {
                    const offset = 200;
                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                        top: elementPosition - offset,
                        behavior: 'smooth'
                    });
                }
            }, 300);
        }
    }, [location]);
    
    return (
        <>
            <Helmet>
                            <title>Złota Centrum Zdrowia | O Nas</title>
                            <meta
                              name="description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                            {/* Open Graph / Facebook */}
                            <meta property="og:type" content="website" />
                            <meta property="og:url" content={window.location.href} />
                            <meta property="og:title" content="Złota Centrum Zdrowia | O Nas" />
                            <meta
                              property="og:description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                    
                            {/* Twitter */}
                            <meta property="twitter:card" content="summary" />
                            <meta property="twitter:url" content={window.location.href} />
                            <meta property="twitter:title" content="Złota Centrum Zdrowia | O Nas" />
                            <meta
                              property="twitter:description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                          </Helmet>
             <div id="o-nas" />
            <Navbar />
             <ServiceBanner title='O Nas' />
            <div className="about-us-container container section-m section-pt">
                <SectionTitle title='Poznaj nasz zespół' />
            </div>
            <ExpertReverse
                 label="USG"
                 title="lek. Klaudia Siemińska"
                description='Lekarz w trakcie specjalizacji z Radiologii i Diagnostyki Obrazowej w Wojewódzkim Szpitalu Zespolonym w Kielcach. Absolwentka Wydziału Lekarskiego Uniwersytetu Medycznego w Łodzi. Doświadczenie zawodowe zdobywała także 
                    w Świętokrzyskim Centrum Onkologii oraz w Szpitalu Wojewódzkim im. Świętego Łukasza w Tarnowie. Członek Polskiego Lekarskiego Towarzystwa Radiologicznego. Uczestniczy w licznych kursach, aby zapewnić pacjentom dokładną diagnostykę i pomoc m.in. USG doppler naczyń, USG narządu ruchu z elementami reumatologii, ultrasonografia interwencyjna dla terapii kolagenowej. Współzałożyciel "Złota Centrum Zdrowia".'
                 photo={klaudiaPhoto}
           
            />
            <Expert
                  label="USG"
                  title="lek. Przemysław Siemiński"
                description={'Lekarz w trakcie specjalizacji z Radiologii i Diagnostyki Obrazowej w Narodowym Instytucie Onkologii - Państwowym Instytucie Badawczym w Gliwicach. Absolwent Wydziału Lekarskiego Uniwersytetu Medycznego w Łodzi. Członek Polskiego Lekarskiego Towarzystwa Radiologicznego. Z zamiłowaniem poszerza swoją wiedzę i umiejętności, uczestnicząc w licznych kursach i konferencjach. Doświadczenie zawodowe zdobywa w wielu placówkach. Współzałożyciel "Złota Centrum Zdrowia".'}
                  photo={przemekPhoto}
               
            />
           
            <ExpertReverse
                 label="REHABILITACJA MEDYCZNA"
                 title="lek. Piotr Siemiński"
                description='Lekarz specjalista Rehabilitacji Medycznej. Absolwent Wydziału Lekarskiego Uniwersytetu Medycznego w Łodzi. Szkolenie specjalizacyjne odbywał w Klinice Rehabilitacji Ortopedycznej i Pourazowej Uniwersyteckiego Szpitala Klinicznego im. Wojskowej Akademii Medycznej- Centralnym Szpitalu Weteranów w Łodzi oraz 21 Wojskowym Szpitalu Uzdrowiskowo-Rehabilitacyjnym w Busku Zdroju. Aktywny członek Polskiego Towarzystwa Rehabilitacji gdzie pełni funkcję Przewodniczącego Sekcji Młodych Lekarzy i Specjalizantów Rehabilitacji Medycznej. Wiceprezes Stowarzyszenia Lekarzy Rehabilitacji. W praktyce zawodowej łączy pasję do aktywności fizycznej z wiedzą medyczną w tym 
                    z zakresu terapii manualnej, ultrasonografii, kinezyterapii oraz fizykoterapii. Wykonuje procedury małoinwazyjne przeciwbólowe i regeneracyjne
                     w leczeniu urazów oraz chorobie zwyrodnieniowej. Uczestnik staży i kursów doskonalących z zakresu USG i nowoczesnych metod leczenia w obrębie narządu ruchu. Współzałożyciel „Złota Centrum Zdrowia”'
                 photo={piotrPhoto}
               
            />
            <Expert
                 label="CHIRURGIA"
                 title="lek. Marcin Sikora"
                 description="Lekarz w trakcie specjalizacji z Chirurgii Ogólnej w Szpitalu Artmedik w Jędrzejowie. Absolwent Collegium Medicum Uniwersytetu Jagiellońskiego w Krakowie.
 Członek Polskiego Towarzystwa Chirurgów Polskich.
 Czynnie dyżuruje w ramach oddziałów chirurgicznych oraz w SOR."
                 photo={marcinPhoto}
            />
                        <ExpertReverse
                label="REUMATOLOGIA"
                title="lek. Karolina Błyskun-Łukaszczyk"
                description="Lekarz specjalista w dziedzinie Reumatologii. Absolwent Uniwersytetu Medycznego w Lublinie. Aktualnie pracuje w Klinice Reumatologii i Immunologii Szpitala Specjalistycznego im. J. Dietla w Krakowie w Małopolskim Ośrodku Reumatologii. Dodatkowo prowadzi terapie biologiczne RZS, ŁZS, ZZSK oraz SpA-postać nieradiograficzna w ramach NFZ w Wojewódzkiej Poradni Reumatologicznej. 
   Uczestnik licznych kongresów oraz sympozjów naukowych, w trakcie których stale poszerza wiedzę i doświadczenie w zakresie reumatoidalnego zapalenia stawów, łuszczycowego zapalenia stawów, zesztywniającego zapalenia stawów kręgosłupa, spondyloartropatii zapalnych, twardziny układowej, tocznia rumieniowatego układowego oraz kursach badania USG układu mięśniowo-szkieletowego i kapilaroskopii. Przyjmuje pacjentów dorosłych (powyżej 18 r.ż.)"
                photo={karolinaPhoto}
            />
            {/* <Expert
                 label="PEDIATRIA"
                 title="lek. Daria Ivantsiv"
                 description="Lekarz specjalizujący się w dziedzinie Pediatrii. Absolwentka Iwano-Frankiwskiego Narodowego Uniwersytetu Medycznego na kierunku pediatrycznym. Ukończyła szkolenie specjalizacyjne w dziedzinie Pediatrii na Vinnytsia National Pirogov Medical University. Pracuje na Oddziale Pediatrycznym Szpitala Rejonowego w Busku Zdroju oraz w Poradni Dziecięcej Przychodni Rejonowej w Pińczowie. Doświadczenie zawodowe zdobywała także jako lekarz pediatra w Szepetowskim Ośrodku Podstawowej Opieki Medycznej, w prywatnym centrum medycznym &quot;Silicea&quot; oraz na Oddziale Noworodkowym Szpitala Powiatowego w Busku Zdroju. Uczestniczy w licznych szkoleniach w zakresie pediatrii oraz kursach."
                 photo={dariaPhoto}
            /> */}
                   <Expert
                label="NEUROLOGIA"
                title="lek. Zuzanna Sroka-Chwalińska"
                description="Lekarz w trakcie specjalizacji z Neurologii w Szpitalu Specjalistycznym im. Ludwika Rydygiera w Krakowie. Absolwentka Collegium Medicum Uniwersytetu Jagiellońskiego w Krakowie. Członek Polskiego Towarzystwa Neurologii. Stale doskonali swoją wiedzę przez uczestnictwo w kursach, szkoleniach i konferencjach. W pracy kieruję się kompleksowym i empatycznym podejściem do pacjenta."
                photo={zuzannaPhoto}
            />
             <ExpertReverse
                 label="ENDOKRYNOLOGIA"
                 title="lek. Izabela Płachta"
                 description="Absolwentka Wydziału Lekarskiego Uniwersytetu Medycznego w Łodzi. Obecnie finalizuje szkolenie specjalizacyjne w dziedzinie endokrynologii w Klinice Endokrynologii Świętokrzyskiego Centrum Onkologii. Posiada potwierdzoną wiedzę specjalistyczną, co poświadcza złożony z wynikiem pozytywnym Państwowy Egzamin Specjalizacyjny. Jest aktywnym członkiem Polskiego Towarzystwa Endokrynologicznego, a swoją wiedzę stale poszerza, uczestnicząc w licznych kursach i konferencjach naukowych."
                 photo={izabelaPhoto}
            />
            <Gallery id="galeria" />
            <Footer />
        </>
    );
};

export default About;